import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Signup.css';

const ContactUs = () => {
  const symbols = ['🛟', '🧠', '🛡️', '💬', '📩', '🤝', '❓', '📞', '🧰', '🔧', '💡', '📢'];
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // No validation, just submit and reset form
    setSubmitted(true);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <div
      className="animated-bg d-flex flex-column min-vh-100 justify-content-center align-items-center pt-0"
      style={{ background: 'linear-gradient(135deg, #e0f7ff, #ffe0f0)', position: 'relative' }}
    >
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Contact Us - LuvMarry Support</title>
        <meta
          name="description"
          content="Need help, want to report an issue, or have feedback? Contact LuvMarry support via email or our online contact form."
        />
        <meta
          name="keywords"
          content="LuvMarry contact, support, help, report abuse, feedback, contact form, dating platform support"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Contact LuvMarry Support" />
        <meta
          property="og:description"
          content="Reach out to LuvMarry for help, suggestions, or to report an issue. We're here to support you."
        />
        <meta property="og:image" content="/LuvMarryLogoPink.png" />
        <meta property="og:url" content="https://usa.luvmarry.com/ContactsUs" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact LuvMarry Support" />
        <meta
          name="twitter:description"
          content="Need help or want to report something? Contact LuvMarry's support team directly."
        />
        <meta name="twitter:image" content="/LuvMarryLogoPink.png" />
      </Helmet>

      {/* Floating symbols */}
      {Array.from({ length: 25 }).map((_, i) => {
        const symbol = symbols[Math.floor(Math.random() * symbols.length)];
        return (
          <span
            key={i}
            className="position-absolute"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              fontSize: `${12 + Math.random() * 14}px`,
              opacity: 0.05,
              animation: `floatDown ${20 + Math.random() * 15}s linear infinite`,
              userSelect: 'none',
              pointerEvents: 'none',
              zIndex: 0,
            }}
            aria-hidden="true"
          >
            {symbol}
          </span>
        );
      })}

      <div className="container" style={{ maxWidth: 600, zIndex: 2 }}>
        <div className="card shadow rounded-4 p-4">
          <div className="text-center mb-3">
            <i className="bi bi-life-preserver text-pink fs-1"></i>
            <h1 className="fw-bold mt-2">Contact Us</h1>
            <p className="text-muted">
              Reach out for help, suggestions, or to report anything 🛟
            </p>
          </div>

          <ul className="list-group list-group-flush mb-4">
            <li className="list-group-item d-flex align-items-start gap-3">
              <i className="bi bi-flag-fill text-danger fs-4"></i>
              <div>
                <strong>Report fake or abusive profiles</strong>
                <br />
                Your safety matters to us.
              </div>
            </li>
            <li className="list-group-item d-flex align-items-start gap-3">
              <i className="bi bi-bug-fill text-warning fs-4"></i>
              <div>
                <strong>Found a bug or issue?</strong>
                <br />
                We’ll fix it quickly!
              </div>
            </li>
            <li className="list-group-item d-flex align-items-start gap-3">
              <i className="bi bi-lightbulb-fill text-info fs-4"></i>
              <div>
                <strong>Have feedback or suggestions?</strong>
                <br />
                We’d love to hear from you.
              </div>
            </li>
            <li className="list-group-item d-flex align-items-start gap-3">
              <i className="bi bi-person-lines-fill text-primary fs-4"></i>
              <div>
                <strong>General inquiries</strong>
                <br />
                We’re here to help.
              </div>
            </li>
          </ul>

          <div className="text-center mb-4">
            <p className="text-muted mb-1">You can also email us directly at:</p>
            <h6>
              <a
                href="mailto:customercare@usa.luvmarry.com"
                className="text-decoration-none text-pink"
              >
                customercare@usa.luvmarry.com
              </a>
            </h6>
          </div>

          <hr />

          {/* Contact form (optional - currently commented out) */}
          {/* {!submitted ? (
            <form onSubmit={handleSubmit} noValidate>
              <div className="mb-3">
                <label htmlFor="name" className="form-label fw-semibold">
                  Name
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your full name"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label fw-semibold">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="form-control"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label fw-semibold">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  className="form-control"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Write your message here..."
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-pink btn-lg fw-bold">
                  Send Message
                </button>
              </div>
            </form>
          ) : (
            <div className="alert alert-success text-center" role="alert">
              Thank you for contacting us! We will get back to you soon.
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
